import { useEffect } from "react";

import { Text } from "@design-system/Text/Text";

import classes from "./ImpersonationBanner.module.css";

export const ImpersonationBanner = () => {
  const impersonationSession = sessionStorage.getItem("impersonation_session");

  useEffect(() => {
    if (impersonationSession) {
      document.documentElement.style.setProperty(
        "--addon-banner-height",
        "30px",
      );
    }
  }, [impersonationSession]);

  if (!impersonationSession) {
    return null;
  }

  const bannerText = "You are impersonating another user - thread carefully!";

  return (
    <div className={classes.banner}>
      <Text color="white" weight={500} size={12}>
        {bannerText}
      </Text>
    </div>
  );
};
